<mat-toolbar id="menu-toolbar" class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
    <a *ngIf="isUserAuthenticated" mat-button routerLink="/home" routerLinkActive="horizontal-active-link"
        [routerLinkActiveOptions]="{exact:true}">Home</a>
    <a mat-button routerLink="/products">Products</a>
    <a mat-button routerLink="/contact" routerLinkActive="horizontal-active-link"
        [routerLinkActiveOptions]="{exact:true}">Contact</a>
</mat-toolbar>